import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { styled } from "@mui/material/styles";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
// Our components
import Carrier from '../General/Carrier'
import NorowsData from '../General/NorowsData'
import Date from '../../pages/General/Date'
import Notification from '../../pages/General/Notification';
import Filters from './Filters';
import Search from './Search';
// mui components
import {
    Typography,
    InputAdornment,
    FormControl,
    Pagination,
    Tooltip,
    Card,
    CardHeader,
    CardContent,
    Divider,
    IconButton
} from "@mui/material";
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';


import { fetchClaimsData, storeClaimsData, resetClaimsState } from './claimsSlice';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper'
};
const Input = styled("input")({
    display: "none",
  });
  const Input1 = styled("input")({
    display: "none",
  });

const UploadDashedBox = styled(Box)(({ theme, hasError }) => ({
    width: '100%',
    padding: '16px 20px',
    borderRadius: '10px',
    border: '2px dashed',
    borderColor: hasError ? '#d32f2f' : '#CBD5E1',
    backgroundColor: '#F8FAFC',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
        borderColor: hasError ? '#c62828' : '#1E293B',
        backgroundColor: '#F1F5F9'
    }
}));

const formFieldStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1E293B',
            boxShadow: '0 0 0 3px rgba(30, 41, 59, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 12px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1E293B',
            fontWeight: 600
        }
    },
    '& .MuiSelect-select, & input': {
        padding: '11px 14px',
        fontSize: '14px',
        color: '#1E293B'
    }
};
const ClaimsPage = () => {

    const dispatch = useDispatch();
    const claims = useSelector(state => state.claims);
    const profile = useSelector(state => state.auth.profile);  
    const [meta, setMeta] = useState(claims.meta);
    const [modalVisible, setModalVisible] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [fileName, setFileName] = useState([])
    const [invoiceFileName, setInvoiceFileName] = useState("")
    const [invoiceFileError, setInvoiceFileError] = useState("")
    const [invoiceFileUpload, setInvoiceFileUpload] = useState("");
    
    const initialValues = {
        tracking_number:"",
        package_value: "",
        claim_type: "",
        claim_status: "PENDING",
        file:[]
      };
      const [values, setValues] = useState(initialValues);
      const [errors, setErrors] = useState({});   
      
      const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('tracking_number' in fieldValues)
            temp.tracking_number = fieldValues.tracking_number ? "" : "This field is required."
        if (values.claim_type === 'UNUSED') {
            temp.package_value = ""; 
        } else {
            if ('package_value' in fieldValues) {
                const val = fieldValues.package_value;
                if (!val) {
                    temp.package_value = "This field is required.";
                } else if (isNaN(val) || parseFloat(val) <= 0) {
                    // ADDED: Check if value is greater than zero
                    temp.package_value = "Value must be greater than zero.";
                } else {
                    temp.package_value = "";
                }
            }
        }
        if ('claim_type' in fieldValues)
            temp.claim_type = fieldValues.claim_type ? "" : "This field is required."
        if(values.claim_type==='DAMAGE'){
            if ('file' in fieldValues)
                temp.file = fieldValues.file ? "" : "This field is required."
        }
        setErrors({
            ...temp
        })

        if (fieldValues === values) {
            return Object.values(temp).every(x => x == "")
        }
    }

    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }
   
       const onFileUpload = (e, field_name) => {
            if (field_name === 'damageproof') {
                const files = Array.from(e.target.files); // ✅ Flatten FileList
                const previewUrls = files.map(file => URL.createObjectURL(file));
                setFileName(previewUrls); // For preview display
                setValues(prev => ({
                ...prev,
                file: files // ✅ Store flat array of File objects
                }));
                validator({ file: files });
            } else {
                // Invoice file upload
                if (e.target.files && e.target.files.length > 0) {
                const file = e.target.files[0];
                setInvoiceFileUpload(file);
                setInvoiceFileName(URL.createObjectURL(file));
                }
            }
        };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isValid = validator(values);
        if (isValid) {
            if ((values.claim_type !== 'UNUSED' && invoiceFileUpload) || values.claim_type === 'UNUSED') {
                const formData = new FormData();
                formData.append("invoice_file", invoiceFileUpload);
                formData.append("tracking_number", values.tracking_number);
                
                // If claim type is UNUSED, append 0, otherwise append actual input value ---
                formData.append("package_value", values.claim_type === 'UNUSED' ? 0 : values.package_value);
                
                formData.append("claim_type", values.claim_type);
                formData.append("claim_status", "PENDING");

                if (values.claim_type === 'DAMAGE') {
                    values.file.forEach(file => {
                        formData.append("file[]", file); // ✅ Append each file
                    });
                }

                // Optional: log FormData contents
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                dispatch(storeClaimsData(profile?.id, formData, meta));
                onModalClose();
                setInvoiceFileError("");
            } else {
                setInvoiceFileError("Commercial invoice file is required");
            }
        }
    };

    const multipleImageOpen = (e,urls) => {
        e.preventDefault();
        urls.map((item) => (
            window.open(item)
        ))
      };
    const columns = [
        {
            field: 'tracking_number',
            headerName: 'Tracking number',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
        },
        {
            field: 'claim_type',
            headerName: 'Claim type',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                if(params.row.claim_type=='LOST'){
                    return <Chip label={params.row.claim_type} style={{ color: "white",width:'120px',height:'28px' }} color="primary" />
                }else if(params.row.claim_type=='DAMAGE'){
                    return <Chip label={params.row.claim_type}  style={{ color: "white", backgroundColor: '#e52b2b',width:'120px',height:'28px' }} color="success" />
                }else if(params.row.claim_type=='UNUSED'){
                    return <Chip label={params.row.claim_type}  style={{ color: "white", backgroundColor: '#a457d3',width:'120px',height:'28px' }} color="success" />
                }else{
                    return <Chip label={params.row.claim_type}  style={{ color: "white", backgroundColor: '#ffa500',width:'120px',height:'28px' }} color="success" />
                }
            }  
        },
        {
            field: 'package_value',
            headerName: <Typography style={{fontWeight:'600',fontSize:'14px'}}>Commercial Value of Package</Typography>,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align:'right',
            minWidth: 200,
            renderCell: (params) => {
                return "$"+params.row.package_value
            }
        },
        {
            field: 'claim_status',
            headerName: 'Claim Status',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                if(params.row.claim_status=='PENDING'){
                    return <Chip label={params.row.claim_status} color="primary"  style={{ width:'120px',height:'28px' }}/>
                }else if(params.row.claim_status=='APPROVED'){
                    return <Chip label={params.row.claim_status} color="success"  style={{ width:'120px',height:'28px' }}/>
                }else if(params.row.claim_status=='DENIED'){
                    return <Chip label={params.row.claim_status} style={{ color: "white", backgroundColor: '#e52b2b',width:'120px',height:'28px'}} color="success" />
                }
            }
        },
        {
            field: 'claimsurl',
            headerName: 'Document',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                // Convert JSON string to an arrayf
                let urlArray=[]
                if(params && params.row && params.row.claimsurl && params.row.claimsurl!==''){
                    urlArray = JSON.parse(params.row.claimsurl);
                    console.log(urlArray.length)
                }

                if(urlArray.length>1){
                    return <div>
                    <span style={{ marginRight: '10px' }}><Tooltip title="View" placement="left-start">
                        <IconButton 
                            onClick={(e) => multipleImageOpen(e,urlArray)}
                            style={{
                                color: '#1890ff',
                            }}
                            >
                            <RemoveRedEyeIcon />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
                }else if(urlArray.length===1){
                    return <div>
                    <span style={{ marginRight: '10px' }}><Tooltip title="View" placement="left-start">
                        <IconButton 
                            onClick={() => window.open(urlArray, '_blank')}
                            style={{
                                color: '#1890ff',
                            }}
                            >
                            <RemoveRedEyeIcon />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
                }else{
                    return "-"
                }
            }
        },
        {
            field: 'invoice_url',
            headerName: 'Invoice',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                if(params && params.row && params.row.invoice_url &&  params.row.invoice_url!==''){
                    return <div>
                    <span style={{ marginRight: '10px' }}><Tooltip title="View" placement="left-start">
                        <IconButton 
                            onClick={() => window.open(params.row.invoice_url, '_blank')}
                            style={{
                                color: '#1890ff',
                            }}
                            >
                            <RemoveRedEyeIcon />
                        </IconButton>
                    </Tooltip>
                    </span>
                </div>
                }else{
                    return "-"
                }
            }
        },
        {
            field: 'created_at',
            headerName: 'Claim Submitted at',
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                return <Date date={params.row.created_at} />
            }         
        },
        {
            field: 'refund_amount',
            headerName: 'Refunded Amount',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            align:'right',
            minWidth: 200,
            renderCell: (params) => {
                let refundAmount=0
                if(params && params.row && params.row.refund_amount && params.row.refund_amount!=''){
                    refundAmount=params.row.refund_amount;
                }
                return "$"+refundAmount
            }
        },
        {
            field: 'invoice_number',
            headerName: 'Adjusted Invoice Number',
            sortable: false,
            headerClassName: 'super-app-theme--header',
            minWidth: 200,
            renderCell: (params) => {
                if(params && params.row && params.row.invoice_number && params.row.invoice_number!=''){
                    return params.row.invoice_number
                }else{
                    return "-"
                }
            }
        }
    ];

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onChangePerPage = (event) => {
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
    }

    function CustomPagination() {

        return (
            <Pagination
                color="primary"
                shape="circular"
                page={claims && claims.meta && claims.meta.current_page}
                count={claims && claims.meta && claims.meta.last_page}
                onChange={onChangePagination}
            />
        );
    }

    function CustomTotalRows() {

        return (
            <div className="custom-total-rows">
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    Showing {claims && claims.data && claims.data.length} of {(claims && claims.meta && claims.meta.total) ? claims.meta.total : 0}
                </FormControl>
            </div>
        )
    }


    function CustomPagesizeoptions() {

        return (
            <div className="custom-page-size-options">
                <span>
                    Show <select
                        value={meta && meta.per_page}
                        onChange={onChangePerPage}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select> entries
                </span>
            </div>
        )
    }

    function CustomToolbar() {

        return (
            <GridToolbarContainer>
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    const onModalClose = () => {
        setModalVisible(false)
        setErrors({})
        setFileName([])
        setValues(initialValues)
        setInvoiceFileName("")
        setInvoiceFileUpload("")
        setInvoiceFileError("")
    }


    useEffect(() => {
        dispatch(fetchClaimsData(meta));
    }, [meta]);

    return (
        <>

            <Modal
                open={modalVisible}
                onClose={onModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 560, md: 600 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none'
                }}>
                    <Card sx={{ borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0' }}>
                        <CardHeader 
                            title={<Typography variant="h6" sx={{ fontWeight: 800, color: '#1E293B' }}>Submit Claim</Typography>} 
                            sx={{ bgcolor: '#F8FAFC', p: 2.5 }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        <CardContent sx={{ p: 4 }}>
                            <Stack spacing={3}>
                                
                                {/* 1. Claim Type */}
                                <FormControl fullWidth variant="outlined" error={errors.claim_type} sx={formFieldStyles}>
                                    <InputLabel id="claim-type-label">Claim Type*</InputLabel>
                                    <Select
                                        labelId="claim-type-label"
                                        id="claim-type-select"
                                        name="claim_type"
                                        defaultValue={values && values.claim_type}
                                        onChange={onInputChange}
                                        label="Claim Type"
                                    >
                                        <MenuItem value={"LOST"}>Lost</MenuItem>
                                        <MenuItem value={"DAMAGE"}>Damage</MenuItem>
                                        <MenuItem value={"MISDELIVERY"}>Misdelivery</MenuItem>
                                        <MenuItem value={"MISSING"}>Missing</MenuItem>
                                        <MenuItem value={"UNUSED"}>Unused</MenuItem>
                                    </Select>
                                    {errors.claim_type && <FormHelperText sx={{ ml: 0.5, mt: '6px' }}>{errors.claim_type}</FormHelperText>}
                                </FormControl>

                                {/* 2. Tracking Number */}
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    sx={formFieldStyles}
                                    label="Tracking Number*"
                                    name="tracking_number"
                                    defaultValue={values && values.tracking_number}
                                    onChange={onInputChange}
                                    error={errors.tracking_number}
                                    helperText={errors.tracking_number}
                                />

                                {/* 3. Commercial Value of Package (With dynamic Profile Currency code) */}
                                {values && values.claim_type !== 'UNUSED' && (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={formFieldStyles}
                                        label="Commercial Value of Package*"
                                        type="text"
                                        name="package_value"
                                        defaultValue={values && values.package_value}
                                        onChange={onInputChange}
                                        error={errors.package_value}
                                        helperText={errors.package_value}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Typography sx={{ fontWeight: 700, fontSize: '13px', color: '#64748B', mr: 0.5 }}>
                                                        {profile?.currency_code || ""}
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}

                                {/* 4. Damage Proof Attachments Box */}
                                {values && values.claim_type === 'DAMAGE' && (
                                    <Box>
                                        <label htmlFor="contained-button-file-damage" style={{ width: '100%', display: 'block' }}>
                                            <Input
                                                accept="image/*,application/pdf"
                                                id="contained-button-file-damage"
                                                onChange={(e) => onFileUpload(e, "damageproof")}
                                                multiple
                                                name="file"
                                                type="file"
                                            />
                                            <UploadDashedBox hasError={errors.file}>
                                                <CloudUploadIcon sx={{ color: errors.file ? '#d32f2f' : '#64748B', fontSize: 24 }} />
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#334155' }}>
                                                        Upload Damage Package Proof
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#94A3B8', display: 'block' }}>
                                                        Images or PDF documentation
                                                    </Typography>
                                                </Box>
                                            </UploadDashedBox>
                                        </label>
                                        
                                        {fileName.length > 0 && (
                                            <Stack spacing={0.5} sx={{ mt: 1.5, pl: 0.5 }}>
                                                {fileName.map((url, index) => (
                                                    <Box key={index} display="flex" alignItems="center" gap={1}>
                                                        <AttachFileIcon sx={{ fontSize: 13, color: '#64748B' }} />
                                                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569', fontSize: '11px' }}>
                                                            Filename: {url}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Stack>
                                        )}
                                        {errors.file && <FormHelperText error sx={{ ml: 0.5, mt: '6px' }}>{errors.file}</FormHelperText>}
                                    </Box>
                                )}

                                {/* 5. Invoice Upload Box */}
                                <Box>
                                    <label htmlFor="contained-button-file-invoice" style={{ width: '100%', display: 'block' }}>
                                        <Input
                                            accept="application/pdf"
                                            id="contained-button-file-invoice"
                                            onChange={(e) => onFileUpload(e, "invoice_file")}
                                            name="invoice_file"
                                            type="file"
                                            style={{ display: "none" }}
                                        />
                                        <UploadDashedBox hasError={invoiceFileName === "" && invoiceFileError}>
                                            <CloudUploadIcon sx={{ color: (invoiceFileName === "" && invoiceFileError) ? '#d32f2f' : '#64748B', fontSize: 24 }} />
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#334155' }}>
                                                    Upload Invoice Documentation
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: '#94A3B8', display: 'block' }}>
                                                    PDF format required
                                                </Typography>
                                            </Box>
                                        </UploadDashedBox>
                                    </label>
                                    
                                    {invoiceFileName && (
                                        <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1.5, pl: 0.5 }}>
                                            <AttachFileIcon sx={{ fontSize: 13, color: '#64748B' }} />
                                            <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569', fontSize: '11px' }}>
                                                Filename: {invoiceFileName}
                                            </Typography>
                                        </Box>
                                    )}
                                    {invoiceFileName === "" && invoiceFileError && (
                                        <FormHelperText error sx={{ ml: 0.5, mt: '6px' }}>{invoiceFileError}</FormHelperText>
                                    )}
                                </Box>

                            </Stack>

                            <Divider sx={{ my: 3.5, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                            {/* Footer Action Controls Row */}
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={onModalClose}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        px: 3.5,
                                        borderColor: '#E2E8F0',
                                        color: '#475569',
                                        '&:hover': {
                                            borderColor: '#CBD5E1',
                                            backgroundColor: '#F1F5F9',
                                            color: '#1E293B'
                                        }
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        px: 5,
                                        boxShadow: 'none',
                                        backgroundColor: '#1E293B',
                                        color: '#FFFFFF',
                                        '&:hover': {
                                            backgroundColor: '#0F172A',
                                            boxShadow: 'none'
                                        }
                                    }}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            {(claims && claims.notification && claims.notification.messageContent!='') &&
            <Notification
                is_open={claims.notification.show}
                messageType={claims.notification.messageType}
                messages={claims.notification.messageContent}
                handleClose={() => dispatch(resetClaimsState())}
            />}
            <div className="scmaincard">
                <div className="sccardhead">
                        <div  style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="h5" gutterBottom component="div">
                                Claims
                            </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <ul className="features-list">
                                <li>
                                <Tooltip title="Create new order" placement="top-start">
                                    <Button variant="outlined" onClick={() => { setModalVisible(true) }}>
                                        <AddCircleOutlineRoundedIcon  /> <span style={{ marginLeft: "8px" }}>New Claim</span>
                                    </Button>
                                </Tooltip>
                                </li>
                                <li>
                                    <Tooltip title="Seacrh" placement="top-start">
                                        <IconButton style={(showSearch) ? { backgroundColor: 'rgb(230, 230, 230)' } : {}} onClick={() => onMenuClick("search", !showSearch)}>
                                            <SearchIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                        </IconButton>
                                    </Tooltip>
                                </li>
                                <li>
                                    <Tooltip title="Filter" placement="top-start">
                                        <IconButton style={(showFilter) ? { backgroundColor: 'rgb(230, 230, 230)' } : {}} onClick={() => onMenuClick("filter", !showFilter)}>
                                            <FilterAltOutlinedIcon style={{ color: 'rgb(25, 118, 210)' }} />
                                        </IconButton>
                                    </Tooltip>
                                </li>
                            </ul>
                        </div>
                </div>
                {showSearch && <Search visible={showSearch} meta={meta} setMeta={setMeta} />}
                {showFilter && <Filters visible={showFilter} meta={meta} setMeta={setMeta} />}
                <div style={{ width: '100%', background: '#fff', marginTop: "20px" }}>
                    <DataGrid
                        style={{ paddingTop: "37px"}}
                        getRowId={(row) => row.id}
                        rows={claims && claims.data}
                        columns={columns}
                        autoHeight={true}
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        sortingMode="server"
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta && meta.sorting && JSON.parse(meta.sorting)}
                        disableRowSelectionOnClick
                        slots={{
                            loadingOverlay: LinearProgress,
                            pagination: CustomPagination,
                            toolbar: CustomToolbar,
                            NorowsData
                        }}
                        loading={
                            (claims && claims.loading)
                        }
                    />
                </div>
            </div >
        </>
    );
}

export default ClaimsPage;